<script setup lang="ts">
  import { computed } from 'vue'
  import Typography from '../Typography/Typography.vue'
  import type { ContentTitleProps } from './types'

  const props = withDefaults(defineProps<ContentTitleProps>(), {
    element: 'h3',
    size: 'text-base',
    weight: 'font-semibold',
    classes: '',
    maxLines: 0,
  })

  const LINE_CLAMP_MAP: Record<number, string> = {
    1: 'line-clamp-1',
    2: 'line-clamp-2',
    3: 'line-clamp-3',
    4: 'line-clamp-4',
    5: 'line-clamp-5',
    6: 'line-clamp-6',
  }

  const clampClass = computed(() =>
    props.maxLines > 0 ? (LINE_CLAMP_MAP[props.maxLines] ?? '') : ''
  )
</script>

<template>
  <Typography
    :element="element"
    :variant="size"
    :weight="weight"
    :classes="[classes, clampClass]"
  >
    {{ text }}
  </Typography>
</template>
